import { render } from "./AdminProducts.vue?vue&type=template&id=f2a16672&ts=true"
import script from "./AdminProducts.vue?vue&type=script&lang=ts"
export * from "./AdminProducts.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__